/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type SourceFilterConfigColumn = (typeof SourceFilterConfigColumn)[keyof typeof SourceFilterConfigColumn];

export const SourceFilterConfigColumn = {
  data_source: 'data_source',
} as const;
